<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
  >
    <div>
      <label class="required">{{ $t('wholesale.date') }}</label>
      <a-date-picker
        v-model="model.stock_out_date"
        format="DD-MM-YYYY"
        valueFormat="DD-MM-YYYY"
        class="ts-w-full"
        :disabled-date="disabledDate"
        @change="invoiceDateChange"
      ></a-date-picker>
      <div class="validate" v-if="errors.has('stock_out_date')">
        {{ errors.first('stock_out_date') }}
      </div>
    </div>
    <div>
        <label class="required">{{ $t('wholesale.customer') }}</label>
        <div class="ts-flex ts-items-center">
          <!-- <a-select
            v-model="model.customer_id"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            showSearch
            :options="customerList"
            @change="onCustomerChange"
            class="ts-w-full"
          ></a-select> -->
          <a-select
            show-search
            v-model="model.customer_id"
            style="width: 100%"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :loading="fetch_customer"
            @search="handleCustomerSearch"
            @change="onCustomerChange"
            filterable
            remote
            :remot-method="searchCustomer"
          >
            <a-select-option
              v-for="c in customerList"
              :key="c.value"
              :value="c.value"
              :opt="c"
            >
              {{ c.label + (c.contact_number ? ' ' + c.contact_number : '') }}
            </a-select-option>
          </a-select>
          <a
            href="#"
            @click.prevent="() => (add_new_customer = true)"
            v-tooltip="$t('add_new')"
            class="ts-bg-blue-500 ts-h-8 ts-w-8 ts-text-white ts-flex ts-items-center ts-rounded-tr ts-rounded-br hover:ts-text-white"
            ><i class="fas fa-plus-square ts-mx-auto"></i
          ></a>
        </div>
        <div class="validate" v-if="errors.has('customer_id')">
          {{ errors.first('customer_id') }}
        </div>
      </div>
   
    <div class="ts-space-y-3">
      <div>
      <label class="required">{{ $t('wholesale.employee') }}</label>
      <a-select
        show-search
        style="width: 100%"
        :default-active-first-option="false"
        :show-arrow="false"
        :filter-option="false"
        :not-found-content="null"
        :loading="fetch_sale"
        @search="handleSaleSearch"
        v-model="model.seller_id"
        :options="employeeList"
        class="ts-w-full"
      ></a-select>
      <div class="validate" v-if="errors.has('seller_id')">
        {{ errors.first('seller_id') }}
      </div>
    </div>
      <div class="ts-pl-4">
        <p>
          {{ $t('wholesale.creditAmount') }}:
          <span class="ts-ml-3 ts-text-red-600">{{
            creditAmount ? $defaultCurrencyWithCode(creditAmount) : 0
          }}</span>
        </p>
        <p class="ts-mb-0">
          {{ $t('wholesale.creditDay') }}:
          <input
            v-model.number="model.credit_day"
            @input="creditDayChange"
            type="number"
            class="ts-ml-3 ts-p-1 ts-outline-none"
          />
        </p>
      </div>
    </div>
    <a-drawer
      v-if="add_new_customer"
      :title="$t('wholesale.createNewCustomer')"
      :width="400"
      :zIndex="1020"
      :visible="add_new_customer"
      :body-style="{ paddingBottom: '80px' }"
      :maskClosable="false"
      @close="() => (add_new_customer = false)"
    >
      <AddNewCustomer @cancel="onCancel" @data="setCustomer" />
    </a-drawer>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { debounce } from 'lodash'
import AddNewCustomer from './add-new-customer.vue'
import TitleBackDate from './title-back-date'
export default {
  name: 'customerSaleDate',
  props: ['value', 'validate'],
  components: {
    AddNewCustomer,
    TitleBackDate
  },
  data() {
    return {
      errors: new Errors(),
      add_new_customer: false,
      model: {},
      fetch_customer: false,
      fetch_sale: false,
      allow_back_date_sale_inovice: null
    }
  },
  created() {
    this.model = this.value
    this.getAllowBackDateSaleInovice()
    this.handleCustomerSearch(null)
    this.handleSaleSearch(null)
    this.model.seller_id = this.$store.state.authUser.user.employee_id
  },
  computed: {
    ...mapState('wholesale/operation', ['customers', 'employees']),
    employeeList() {
      return this.employees
      .filter(em => em.employee_id == this.$store.state.authUser.user.employee_id)
      .map(el => ({
        value: el.employee_id,
        label: el.employee_name_en
      }))
    },
    customerList() {
      return this.customers.map(el => ({
        value: el.customer_id,
        label: el.ss_id_card
          ? el.ss_id_card + '|' + el.customer_name
          : el.customer_name,
        credit_amount: el.credit_amount,
        contact_number: el.contact_number,
        credit_day: el.credit_day,
        employee_id: el.employee_id
      }))
    },
    creditAmount() {
      let cus = this.customers.find(
        c => c.customer_id == this.model.customer_id
      )

      if (cus) {
        return cus.credit_amount
      }
      return 0
    }
  },
  methods: {
    ...mapActions('wholesale/operation', [
      'getCustomer',
      'getSale',
      'getFormViewData'
    ]),
    getAllowBackDateSaleInovice() {
      this.getFormViewData({
        params: {
          fnName: 'allowBackDateSaleInovice'
        }
      }).then(response => {
        this.allow_back_date_sale_inovice =
          response.data.allowBackDateSaleInovice.allow_back_date_sale_inovice
      })
    },
    disabledDate(current) {
      let current_date = new Date() // Current date and time
      let allow_date = new Date(current_date) // Create a new Date object with the current date and time
      allow_date.setDate(
        current_date.getDate() - this.allow_back_date_sale_inovice - 1
      )
      return current && current.valueOf() < allow_date
    },
    onCustomerChange(value, opt) {
      this.model.credit_day = opt.data.attrs.opt.credit_day
      this.creditDayChange()
      this.getSale(opt.data.attrs.opt.employee_id)
    },
    creditDayChange() {
      if (this.model.amount_due > 0) {
        this.updateNextPaymentDate()
      }
    },
    invoiceDateChange() {
      if (this.model.current_date > this.model.stock_out_date) {
        this.$confirm({
          title: this.$t('are_you_sure_to_create_back_date'),
          content: h => h(TitleBackDate),
          okText: this.$t('yes'),
          okType: 'danger',
          cancelText: this.$t('no'),
          onOk: () => {
            this.clearInputDetail()
            this.$emit('checkBackDate')
          },
          onCancel: () => {
            this.$emit('checkBackDate')
            this.backDateToCurrentDate()
          }
        })
      }
      if (!this.model.current_date > this.model.stock_out_date) {
        this.updateNextPaymentDate()
      }
      if (this.model.current_date == this.model.stock_out_date) {
        this.model.product_detail = []
        this.model.is_check_back_date = false
        this.$emit('checkBackDate')
      }
    },
    backDateToCurrentDate() {
      this.model.stock_out_date = this.model.current_date
    },
    clearInputDetail() {
      this.model.product_detail = []
      this.model.quotation_id = ''
      this.model.contract_id = ''
      this.model.is_check_back_date = true
    },
    updateNextPaymentDate() {
      let add_day = this.model.credit_day ? this.model.credit_day : 7
      if (this.model.stock_out_date && this.model.amount_due > 0) {
        this.model.next_payment_date = moment(
          this.model.stock_out_date,
          'DD-MM-YYYY'
        )
          .add(add_day, 'days')
          .format('DD-MM-YYYY')
      }
    },
    onCancel() {
      this.add_new_customer = false
    },
    setCustomer(data) {
      this.$store.commit('wholesale/operation/PUSH_NEW_CUSTOMER', data)
      this.model.customer_id = data.customer_id
      this.creditDayChange()
    },
    searchCustomer: debounce(async function(query) {
      var avoidSearch = this.customerList.find(
        c => c.label + '-' + c.contact_number == query.trim()
      )
      if (avoidSearch) return
      this.fetchResource({
        fnName: 'customerList',
        customer_search: query
      })
    }, 500),
    handleCustomerSearch: debounce(function(value) {
      this.fetch_customer = true
      this.getCustomer({ search: value }).finally(
        () => (this.fetch_customer = false)
      )
    }, 500),
    handleSaleSearch: debounce(function(value) {
      this.fetch_sale = true
      this.getSale(value).finally(() => (this.fetch_sale = false))
    }, 500)
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    },
    'model.customer_id': function() {
      this.updateNextPaymentDate()
    }
  }
}
</script>
